/**
 * Created by jiachenpan on 16/11/18.
 */
import store from '../store'
import router from '@/router'
import Cookies from 'js-cookie'
export function parseTime(time) {
  if (time) {
    var date = new Date(time)
    var year = date.getFullYear()
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return ''
  }
}

export function parseDay(time) {
  if (time) {
    var date = new Date(time)
    var year = date.getFullYear()
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    return year + '-' + month + '-' + day
  } else {
    return ''
  }
}

export function uuid() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return uuid
}
export function simpleUuid() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = ''

  var uuid = s.join('')
  return uuid
}
export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 替换邮箱字符
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    const str = email.split('@')
    let _s = ''
    if (str[0].length > 3) {
      for (var i = 0; i < str[0].length - 3; i++) {
        _s += '*'
      }
    }
    var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
  }
  return new_email
}

// 替换手机字符
export function regMobile(mobile) {
  if (mobile.length > 7) {
    var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return new_mobile
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// export function cbt(row, column, cell, event) {
//   const s = row[column.property]
//   var date = new Date().getTime() + 1000
//   var dataobj = new Date(date)
//   if (Cookies.get('cbt')) {
//     Cookies.set('cbt', Cookies.get('cbt') + 1, { expires: dataobj })
//   } else {
//     Cookies.set('cbt', 0, { expires: dataobj })
//   }
//   if (Cookies.get('cbt') > 2) {
//     var textarea = document.createElement('textarea')
//     document.body.appendChild(textarea)
//     // 赋值内容
//     textarea.value = s
//     // 选定
//     textarea.select()
//     // 执行浏览器复制
//     document.execCommand('Copy')
//     // 复制完后移除textarea
//     document.body.removeChild(textarea)
//     // 提示已复制
//     this.$message({
//       message: '已复制',
//       type: 'success'
//     })
//   }
// }

export function cbt(row, column, cell, event) {
  // 获取到子类下的内容 如:row.channelCode.names 分割后为 ['channelCode','names']
  let c = column.property.split(".")
  // 赋值当前行数据
  let s = row
  // 以选中的子类做循环条件
  c.forEach(item => {
    // 第一次运行 s = row[channelCode]
    // 第二次运行 s = row[channelCode][names]
    s = s[item]
  })
  // console.log("sssssss", s)
  if (s) {
    var textarea = document.createElement('textarea')
    document.body.appendChild(textarea)
    // 赋值内容
    textarea.value = s
    // 选定
    textarea.select()
    // 执行浏览器复制
    document.execCommand('Copy')
    // 复制完后移除textarea
    document.body.removeChild(textarea)
    // 提示已复制
    this.$message({
      message: '已复制',
      type: 'success'
    })
  } else {
    // 提示为空
    this.$message({
      message: '复制内容为空',
      type: 'error'
    })
  }


}

export function getDepNameByDomain() {
  // 测试环境：优先使用 __platform 参数
  const params = new URLSearchParams(window.location.search)
  const debugPlatform = params.get('__platform')
  if (debugPlatform) {
    return debugPlatform
  }
  // 生产环境：从域名提取第一个部分
  return window.location.hostname.split(".")[0]
}

export function getWxUserInfo() {
  // %7B%22country%22%3A%22%22%2C%22province%22%3A%22%22%2C%22city%22%3A%22%22%2C%22openid%22%3A%22owqTC6ctWI6TBx9P-1fnJdSZwT0Q%22%2C%22sex%22%3A0%2C%22nickname%22%3A%22J0N%22%2C%22headimgurl%22%3A%22https%3A%2F%2Fthirdwx.qlogo.cn%2Fmmopen%2Fvi_32%2FDaVY0Sia1UXpd9o8z70fpInvdje1C5wic1rxDA8XbwlFlS74Mcco0yRYFDiaK8TwE4gsHcmMtIcp3l02BzE8QlJPw%2F132%22%2C%22language%22%3A%22%22%2C%22privilege%22%3A%5B%5D%7D
  // decode 并转为json对象
  if (Cookies.get('wxUserInfo')) {
    let wxUserInfoStr = decodeURIComponent(Cookies.get('wxUserInfo'));
    return JSON.parse(wxUserInfoStr);;
  } else {
    return null;
  }

  // return window.location.hostname.split(".")[0];

}

export function isDevelopment() {
  return process.env.NODE_ENV === "development";
}





// WEBPACK FOOTER //
// ./src/utils/index.js